<script setup lang="ts">
const {
  searchKeyword,
  hasLawComment,
  toggleHasLawComment,
  hasLawCommentCount,
  legalAreaFacetOptions,
  authorFacetOptions,
  legalAreaSelected,
  authorSelected,
  toggleLegalArea,
  toggleAuthor,
  searchLegalArea,
  searchAuthor,
  isLoading,
} = useLawFilters()
</script>

<template>
  <aside aria-label="Filtervalg" class="flex flex-col gap-m w-[369px] pt-l">
    <div class="flex flex-col gap-s">
      <label for="law-title-filter" class="title-s font-bold">
        Filtrer på lov eller rettsområde
      </label>
      <FormSearchInput
        id="law-title-filter"
        v-model="searchKeyword"
        external-label
        resettable
        shape="square"
        size="medium"
      />
    </div>

    <div class="flex items-center justify-between gap-s pl-2xs pr-m py-2xs">
      <FormCheckbox
        label="Med lovkommentar"
        name="hasLawComment"
        :model-value="hasLawComment"
        @update:model-value="toggleHasLawComment"
      />
      <span class="text-caption text-secondary shrink-0">{{ hasLawCommentCount }}</span>
    </div>

    <FilterSkeleton v-if="isLoading" />

    <div v-if="legalAreaFacetOptions.length" class="flex flex-col gap-s">
      <span class="text-small font-bold">Rettsområde</span>
      <FilterFacetList
        v-model:search="searchLegalArea"
        class="gap-s"
        label="Rettsområde"
        name="lawLegalArea"
        expand-noun="rettsområder"
        :options="legalAreaFacetOptions"
        :selected="legalAreaSelected"
        :toggle="toggleLegalArea"
      />
    </div>

    <div v-if="authorFacetOptions.length" class="flex flex-col gap-s">
      <span class="text-small font-bold">Forfattere</span>
      <FilterFacetList
        v-model:search="searchAuthor"
        class="gap-s"
        label="Forfattere"
        name="lawAuthor"
        expand-noun="forfattere"
        :options="authorFacetOptions"
        :selected="authorSelected"
        :toggle="toggleAuthor"
      />
    </div>
  </aside>
</template>